// TOP - mv メインビジュアル
var mySwiper = new Swiper('.js-slider--main', {
	loop: true,
	effect: 'slide',
	speed: 500,
	autoplay: {
		delay: 4000,
	},
	centeredSlides: true, // Center mode ON
	lazy: {
		loadOnTransitionStart: true, // Lazy load ON
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
    },
    navigation: {
        nextEl: '.p-front__fv__slider .swiper-button-next',
        prevEl: '.p-front__fv__slider .swiper-button-prev',
    },
	slidesPerView: 1.8,
	spaceBetween: 30,
	breakpoints: {
		767: {
			slidesPerView: 3,
			spaceBetween: 40,
		}
	}
})
window.addEventListener('load', function() {
    // 関数xとして .p-front__fv__slider--main の高さを取得
    function getSliderHeight() {
        const sliderMain = document.querySelector('.p-front__fv__slider--main');
        return sliderMain ? sliderMain.offsetHeight : 0;
    }

    // ボタンのtop位置を調整する関数
    function adjustButtonPosition() {
        const sliderHeight = getSliderHeight();
        const prevButton = document.querySelector('.p-front__fv__slider--button .swiper-button-prev');
        const nextButton = document.querySelector('.p-front__fv__slider--button .swiper-button-next');
        const screenWidth = window.innerWidth; // 画面幅を取得

        if (prevButton && nextButton && sliderHeight > 0) {
            let buttonTopPosition;

            if (screenWidth <= 768) {
                // 画面幅が768px以下の場合
                buttonTopPosition = -(sliderHeight / 2) + 'px';
            } else {
                // 画面幅が768pxより大きい場合
                buttonTopPosition = -(sliderHeight / 2) - 20 + 'px';
            }

            prevButton.style.top = buttonTopPosition;
            nextButton.style.top = buttonTopPosition;
        }
    }

    // .p-front__fv__slider--main の完全な読み込みを監視する
    const sliderMain = document.querySelector('.p-front__fv__slider--main');

    if (sliderMain) {
        const observer = new MutationObserver((mutationsList, observer) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'attributes' || mutation.type === 'childList') {
                    // 要素の変化が検知されたらボタン位置を調整
                    adjustButtonPosition();
                }
            });
        });

        // 要素の変化を監視
        observer.observe(sliderMain, { attributes: true, childList: true, subtree: true });

        // 初回呼び出し
        adjustButtonPosition();
    }

    // ウィンドウのリサイズ時にも位置を再計算
    window.addEventListener('resize', adjustButtonPosition);
});


// TOP - voice
var mySwiper = new Swiper('.js-slider--voice', {
	loop: true,
	effect: 'slide',
	speed: 500,
	centeredSlides: true, // Center mode ON
	// autoplay: {
	// 	delay: 6000,
	// },
	lazy: {
		loadOnTransitionStart: true, // Lazy load ON
	},
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
    },
    navigation: {
        nextEl: '.p-front__voice__slider .swiper-button-next',
        prevEl: '.p-front__voice__slider .swiper-button-prev',
    },
	slidesPerView: 1.4,
	spaceBetween: 12,
	breakpoints: {
		767: {
			slidesPerView: 2,
			spaceBetween: 40,
				centeredSlides: false, // Center mode ON
		}
	}
})


var mySwiper = new Swiper('.c-slider--gallery__container', {
	loop: true,
	effect: 'slide',
	speed: 2000,
	autoplay: {
		delay: 4000,
	},
	breakpoints: {
		767: {
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 500,
		},
		// ウィンドウサイズが640px以下
		1920: {
			slidesPerView: 2.5,
			spaceBetween: 20

		}
	}
})
